import { render, staticRenderFns } from "./link.code.md?vue&type=template&id=2df0a64e&scoped=true&"
var script = {}
import style0 from "./link.code.md?vue&type=style&index=0&id=2df0a64e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../storefront/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df0a64e",
  null
  
)

export default component.exports